'use strict';

var ImportCsvUserMessageDirective = function ImportCsvUserMessageDirective() {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/import-csv-user-message.html')
  };
};
ImportCsvUserMessageDirective.$inject = [];
module.exports = ImportCsvUserMessageDirective;